<div class="tracking-page-product-widget-container">
  <pdq-card variant="popover" color="white">
    <form [formGroup]="formGroup">
      <div class="card" [formGroupName]="'widgets'">
        <ng-container [formGroupName]="'productSection'">
          <div class="header-container">
            <pdq-heading element="h5">Products</pdq-heading>
            <pdq-slide-toggle formControlName="showProductSection"> </pdq-slide-toggle>
          </div>
          <!-- Main content inside the card -->
          @if (formGroup?.get('widgets.productSection.showProductSection')?.value) {
            <pdq-divider></pdq-divider>
            <div class="card__content">
              <pdq-input label="Widget title" formControlName="title"> </pdq-input>
              <ng-container>
                <pdq-editor-textarea
                  label="Product details"
                  placeholder="Describe what’s included in this shipment"
                  [control]="formGroup?.get('widgets.productSection.bodyText')"
                  [config]="{
                    items: dynamicFieldsAutocompleteOptions$ | async,
                    triggerChar: '{',
                    filterByKey: 'searchTerm',
                    removeTriggerCharOnSelect: true,
                    descriptionKey: 'description',
                    variant: 'categorizedOptions',
                  }"></pdq-editor-textarea>
                <p style="font-size: 14px; color: var(--on-surface-light)">
                  {{ 'Tip: Use dynamic field type { to see options.' }}
                  <img
                    src="assets/icons/icon-info.svg"
                    class="form-title-info-icon"
                    matTooltip="In the live tracking page, if the dynamic field has no value, the entire field will be hidden for the relevant products to avoid empty label."
                    matTooltipClass="pdq-mat-tooltip" />
                </p>
              </ng-container>
            </div>
          }
        </ng-container>
      </div>
    </form>
  </pdq-card>
</div>
